const CART_KEY = "ekman_cart";

export const getCartItems = () => {
  try {
    const raw = localStorage.getItem(CART_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const saveCartItems = (items) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event("cart-updated"));
  } catch {
    // Quota exceeded - clear old cart and try again
    localStorage.removeItem(CART_KEY);
  }
};

export const addToCart = (product, variant, quantity = 1) => {
  const items = getCartItems();
  const existingIndex = items.findIndex(
    (item) => item.slug === product.slug && item.variantId === variant.id
  );

  if (existingIndex >= 0) {
    items[existingIndex].quantity += quantity;
  } else {
    // Don't store image - it's too large. Store only references.
    items.push({
      slug: product.slug,
      name: product.name,
      variantId: variant.id,
      variantLabel: variant.label,
      variantSize: variant.size,
      price: variant.price,
      quantity,
    });
  }

  saveCartItems(items);
};

export const getCartItemQuantity = (slug, variantId) => {
  const items = getCartItems();
  const item = items.find((i) => i.slug === slug && i.variantId === variantId);
  return item ? item.quantity : 0;
};

export const updateCartItemQuantity = (slug, variantId, quantity) => {
  let items = getCartItems();
  if (quantity <= 0) {
    items = items.filter((item) => !(item.slug === slug && item.variantId === variantId));
  } else {
    const index = items.findIndex((item) => item.slug === slug && item.variantId === variantId);
    if (index >= 0) {
      items[index].quantity = quantity;
    }
  }
  saveCartItems(items);
};

export const removeFromCart = (slug, variantId) => {
  const items = getCartItems().filter(
    (item) => !(item.slug === slug && item.variantId === variantId)
  );
  saveCartItems(items);
};

export const clearCart = () => {
  saveCartItems([]);
};

export const getCartTotal = () => {
  return getCartItems().reduce((sum, item) => sum + item.price * item.quantity, 0);
};
